import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { map } from 'rxjs/operators';
import { SelfEnrollmentsService } from 'services/self-enrollments/self-enrollments.service';
import { getEnrollmentDataForResolver } from 'pages/entry/entry.helpers';
import { PlatformBrandingService } from 'features/organization-settings/platform-branding/platform-branding.service';
import { SelfEnrollmentsPublicResponse } from 'pages/organization/self-enrollments/self-enrollments.interface';

@Injectable()
export class SelfEnrollmentFirstLoginGuardService  {
  constructor(
    private selfEnrollmentsService: SelfEnrollmentsService,
    private router: Router,
    private platformBrandingService: PlatformBrandingService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot) {
    return getEnrollmentDataForResolver(this.selfEnrollmentsService, this.platformBrandingService, this.router).pipe(
      map((data: SelfEnrollmentsPublicResponse) => {
        if (data.enabled) {
          return true;
        }

        const { title, token } = route.params;
        this.router.navigateByUrl(`/entry/self-enrollments/${title}/${token}`);

        return false;
      }),
    );
  }
}

export const selfEnrollmentFirstLoginGuard: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
) => {
    return inject(SelfEnrollmentFirstLoginGuardService).canActivate(route);
};
